<h5 style="margin-top: 10px">Items requiring transport</h5>
<div class="row action-toolbar">
    <div class="col-12">
        <form class="form-inline">
            <action-toolbar-count [grid]="grid"></action-toolbar-count>
            <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
            <action-toolbar-buttons
                [grid]="grid"
                [canEdit]="true"
                [showAdd]="true"
                [showEdit]="true"
                [showDelete]="true"
            ></action-toolbar-buttons>
            <grid-export [grid]="mainGrid" [name]="'Estimate Vs Actual'"></grid-export>
        </form>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <wj-flex-grid
            id="mainGrid"
            #mainGrid
            appAutoSize
            (initialized)="grid.initialize(mainGrid)"
            [itemsSource]="grid.view"
            [itemFormatter]="itemFormatter"
        >
            <wj-flex-grid-filter></wj-flex-grid-filter>
            <wj-flex-grid-column [header]="'Priority'" [binding]="'priority'" [width]="90" [dataMap]="priorityMap"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Description'" [binding]="'description'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'From Job'" [binding]="'fromJob'" [dataMap]="jobMap" [width]="300"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Due Date'" [binding]="'dueDate'" [width]="150"></wj-flex-grid-column>
            <wj-flex-grid-column
                [header]="'Requested By'"
                [binding]="'requestedById'"
                [dataMap]="allUserMap"
                [width]="300"
            ></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Due Date'" [binding]="'dueDate'" [width]="150"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Completed Date'" [binding]="'completionDate'" [width]="150"></wj-flex-grid-column>
        </wj-flex-grid>
    </div>
</div>
